import { UAParser } from 'ua-parser-js';

const parser = new UAParser();

export function getViewportData() {
    return {
        width: window.screen.width,
        height: window.screen.height,
        pixelRatio: window.devicePixelRatio,
    };
}

export function getWindowData() {
    return {
        size: {
            width: window.innerWidth,
            height: window.innerHeight,
        },
        position: {
            x: window.screenLeft || window.screenX,
            y: window.screenTop || window.screenY,
        },
    };
}

export function getBrowserData() {
    return parser.getBrowser();
}

export function getDeviceData() {
    return {
        engine: parser.getEngine(),
        os: parser.getOS(),
    };
}

export const isBrowserSupportedForRecording = () => {
    const engine = parser.getEngine();

    switch (engine.name) {
        case 'Blink': // Chromium
            return true;
        case 'WebKit': // Safari
            return false;
        case 'Gecko': // Firefox
            return false;
        default:
            return false;
    }
};

export const isDesktop = () => {
    const device = parser.getDevice().withFeatureCheck();
    return (
        device.type === undefined ||
        ![
            'console',
            'mobile',
            'tablet',
            'smarttv',
            'wearable',
            'embedded',
        ].includes(device.type)
    );
};

// iOS WebKit (including Chrome-for-iOS) rejects `blob:` URLs for <video>
// playback with MEDIA_ERR_SRC_NOT_SUPPORTED, regardless of the Blob's
// explicit MIME type. Callers that create object URLs for video must fall
// back to the direct resource URL for iOS.
export const isIOS = () => {
    const os = parser.getOS();
    if (os.name === 'iOS') return true;
    // iPadOS 13+ reports as Mac in the UA string; distinguish via touch.
    if (os.name === 'macOS' && navigator.maxTouchPoints > 2) return true;
    return false;
};
